import { MemberWithPermission, TeamWithPermission } from "@zapier/permissions";

export type PermissionRecipientType = "admin" | "individual" | "team";

/**
 * Determines the type of permission recipient (admin, individual, or team) based on the
 * properties of a member or team object for Canvas sharing/permissions.
 *
 * @param memberOrTeam - The member or team object to check
 * @returns The permission recipient type: "admin", "individual", or "team"
 */
export function getPermissionRecipientType(
  memberOrTeam: MemberWithPermission | TeamWithPermission,
): PermissionRecipientType {
  const isAdmin = "role" in memberOrTeam && memberOrTeam.role === "admin";
  const isPerson = !isAdmin && "full_name" in memberOrTeam;
  return isAdmin ? "admin" : isPerson ? "individual" : "team";
}
